import { render, staticRenderFns } from "./SolicitacaoAlteracao.vue?vue&type=template&id=1dc8ae6c&"
import script from "./SolicitacaoAlteracao.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAlteracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports